import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Dropdown } from 'semantic-ui-react'
import { ThemeContext } from 'styled-components'
import i18n from '~/components/i18n'
import { StyledFiltersOptions } from '../../Reporting/TradingActivities/style'

export const getDropdownFilterKeys = () => [
  {
    key: 'tourNumber',
    optionKey: 'tourNumbers',
    placeholder: i18n.t('Tour nr.')
  },
  {
    key: 'vehicleNumber',
    optionKey: 'vehicleNumbers',
    placeholder: i18n.t('Vehicle nr.'),
    filterType: 'dr'
  },
  {
    key: 'driverNumber',
    optionKey: 'driverNumbers',
    placeholder: i18n.t('Driver nr.')
  },
  {
    key: 'totalAmountFrom',
    placeholder: i18n.t('Total amount from (in l)')
  },
  {
    key: 'totalAmountTo',
    placeholder: i18n.t('Total amount to (in l)')
  },
  {
    key: 'tempFrom',
    placeholder: i18n.t('Temp. from'),
    decimalScale: 1
  },
  {
    key: 'tempTo',
    placeholder: i18n.t('Temp. to'),
    decimalScale: 1
  },
  {
    key: 'sampleBottleNumber',
    placeholder: i18n.t('Sample bottle')
  },
  {
    key: 'dateFrom',
    placeholder: i18n.t('Tour start'),
    type: 'date'
  },
  {
    key: 'dateTo',
    placeholder: i18n.t('Tour end'),
    type: 'date'
  },
  {
    key: 'deleted',
    label: 'Gelöschte Touren',
    type: 'checkbox'
  }
]

interface Props {
  checkedFilters: any[]
  handleCheckFilter: (checked: boolean, filter: any, indexFilter: number) => void
}

const FilterDropdown: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { firstColor } = useContext(ThemeContext)

  const { checkedFilters, handleCheckFilter } = props

  const filters = getDropdownFilterKeys()

  return <StyledFiltersOptions
    text={t('Filter')}
    icon='filter'
    floating
    labeled
    button
    closeOnChange={false}
    multiple
    className='icon'
    style={{ background: firstColor, color: 'white' }}
  >
    <Dropdown.Menu >
      <Dropdown.Menu scrolling style={{ overflowY: 'hidden', minHeight: 'max-content' }}>
        {filters.map((filter, indexFilter) => {
          const checked = Boolean(checkedFilters.find(filterChecked => filterChecked.key === filter.key))
          return <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              handleCheckFilter(!checked, filter, indexFilter)
            }}
            key={filter.key}
          >
            <Checkbox
              checked={Boolean(checkedFilters.find(filterChecked => filterChecked.key === filter.key))}
              label={filter.placeholder || filter.label}
            />
          </Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown.Menu>
  </StyledFiltersOptions>
}
export default FilterDropdown